import { useState, useEffect, useRef } from "react";
import { AppContext } from "./AppContext";
import Game from "./Game";
import { useAccount } from "wagmi";
import MintModal from "./components/MintModal";
import PauseOverlay from "./components/PauseOverlay";
import WalletConnectButton from "./components/ConnectButton";
import { Button } from "@mantine/core";
import playButton from "./assets/play.png";
import skipButton from "./assets/2.png";
import youHave from "./assets/youhave.png";
import redCircle from "./assets/redcircle.png";
import howMany from "./assets/howmany.png";
import freeMints from "./assets/freemints.png";
import plus from "./assets/plus.png";
import minus from "./assets/minus.png";
import hellionzSnapshot from "./assets/hellionzSnapshot.json";
import { ethers } from "ethers";
import Layerr721A from "./assets/Layerr721A.json";
import { useEthersSigner } from "./ethers";
import mintAbi from "./assets/LayerrMinter.json";
import "./style.css";
import { MerkleTree } from "merkletreejs";
import snapshot from "./assets/hellionzSnapshot.json";
import freeParams from "./assets/processedFreeMintParams.json";
import paidParams from "./assets/processedHellionzMintParams.json";
import { Buffer } from "buffer";
import choose from "./assets/choose.png";
import ok from "./assets/ok.png";
import mint1 from "./assets/mint.png";
import lfg from "./assets/lfg.png";
import back from "./assets/back.png";
import ethBeforeGas from "./assets/ethbeforegas.png";
import for1 from "./assets/for.png";
import hellionz from "./assets/hellionz.png";
import done from "./assets/done.png";
import loading from "./assets/loading.png";

const App = () => {
  const [isPause, setIsPause] = useState(false);
  //const [isOpen, setIsOpen] = useState(false);
  const [showGame, setShowGame] = useState(false);
  const [showBuying, setShowBuying] = useState(false);
  const [showFree, setShowFree] = useState(false);
  const { isConnected, address } = useAccount();
  const [isLoaded, setIsLoaded] = useState(false);
  const [price, setPrice] = useState(0.013);
  const [isDialogue, setIsDialogue] = useState(false);
  const canvasRef = useRef(null);
  const gameRef = useRef(null);
  const [quantity, setQuantity] = useState(1);
  const [freeBalance, setFreeBalance] = useState(0);
  const [showMinting, setShowMinting] = useState(false);
  const [doneMinting, setDoneMinting] = useState(false);
  const [maskType, setMaskType] = useState("none");
  const signer = useEthersSigner();

  const lockPointer = () => {
    canvasRef.current.requestPointerLock({
      unadjustedMovement: true
    });
    //gameRef.current.unfreezeCamera();
  };

  const unlockPointer = () => {
    document.exitPointerLock();
  };

  const showPauseOverlay = () => {
    setIsPause(true);
  };

  const hidePauseOverlay = () => {
    setIsPause(false);
  };

  /*   const toggleMintModal = () => {
    setIsOpen(!isOpen);
  }; */

  const updateIsDialogue = (value) => {
    setIsDialogue(value);
    console.log("VALUE" + value);
    console.log("ISD" + isDialogue);
  };

  const setMask = (name) => {
    setMaskType(name);
  };

  const showMint = () => {
    setShowGame(false);
    setShowMinting(true);
  };

  /*   useEffect(() => {
    const openMintModal = (event) => {
      if (event.code === "KeyT") {
        toggleMintModal();
        if (isOpen) {
          lockPointer();
        } else {
          unlockPointer();
        }
      }
    };

    document.addEventListener("keydown", openMintModal);
    return () => {
      document.removeEventListener("keydown", openMintModal);
    };
  }); */

  useEffect(() => {
    const checkFree = async () => {
      if (hellionzSnapshot[address] !== undefined) {
        const provider = new ethers.providers.JsonRpcProvider(
          "https://eth-mainnet.g.alchemy.com/v2/9C_BrYLf3uOsP51bBFWwNyWToX-bESih"
        );
        const readerContract = new ethers.Contract(
          "0xc9747f66e42d961d8d762374118538583410bC33",
          Layerr721A,
          provider
        );
        const balance = await readerContract.balanceOf(address);
        const balanceNum = balance.toNumber();
        setFreeBalance(hellionzSnapshot[address] - balanceNum);
        if (balanceNum < hellionzSnapshot[address]) {
          setPrice(0);
          setShowFree(true);
        } else {
          setShowFree(false);
          setPrice(0.013);
        }
      }
    };
    checkFree();
    setMaskType("none");
  }, [address, doneMinting]);

  useEffect(() => {
    const canvas = canvasRef.current;

    const handlePointerLockChange = () => {
      if (document.pointerLockElement === canvas) {
        /*         if (!isOpen && isDialogue) {
          hidePauseOverlay();
        } */
        hidePauseOverlay();
        gameRef.current.unfreezeCamera();
        console.log("Pointer locked");
      } else {
        if (/* !isOpen &&  */ !isDialogue) {
          showPauseOverlay();
        }
        gameRef.current.freezeCamera();
        console.log("Pointer unlocked");
      }
    };

    const handlePointerLockError = () => {
      console.log("Pointer lock error");
    };

    canvas.addEventListener("click", (e) => {
      if (!e.target.className.includes("zombies")) {
        // If the clicked element is NOT the input
        // lockPointer();
      }
    });

    document.addEventListener("pointerlockchange", handlePointerLockChange);
    document.addEventListener("pointerlockerror", handlePointerLockError);

    return () => {
      document.removeEventListener("pointerlockchange", handlePointerLockChange);
      document.removeEventListener("pointerlockerror", handlePointerLockError);
    };
  }, [/* isOpen,  */ isDialogue]);

  const handleFreePlus = () => {
    console.log(freeBalance);
    if (quantity < freeBalance) {
      setQuantity(quantity + 1);
    }
  };

  const handlePlus = () => {
    setQuantity(quantity + 1);
  };

  const handleMinus = () => {
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };

  const handleFreeInput = (e) => {
    const { value } = e.target;
    console.log(e.target.value);
    if (value >= 1 && value <= freeBalance) {
      setQuantity(value);
    }
  };

  const handleInput = (e) => {
    const { value } = e.target;
    console.log(e.target.value);
    if (value >= 1) {
      setQuantity(value);
    }
  };

  const handleMinusPrice = () => {
    // Convert to number, subtract, and ensure it's no less than the min value
    let newPrice = Math.max(parseFloat(price) - 0.001, 0.013);
    setPrice(newPrice.toFixed(3)); // Update with 3 decimal places
  };

  const handlePlusPrice = () => {
    // Convert to number, add, and ensure it's no more than the max value
    let newPrice = Math.min(parseFloat(price) + 0.001, 0.666);
    setPrice(newPrice.toFixed(3)); // Update with 3 decimal places
  };

  const handleInputPrice = (e) => {
    let value = parseFloat(e.target.value);
    console.log(e.target.value);

    if (isNaN(value)) {
      // if the input is not a number, do nothing
      return;
    }

    // Ensure the value is within the range
    if (value < 0.013) {
      value = 0.013;
    } else if (value > 0.666) {
      value = 0.666;
    }

    setPrice(value.toFixed(3)); // Update with 3 decimal places
  };

  const calculateTotalAmount = async (paymentTokens, signer, quantity) => {
    let totalAmount = ethers.BigNumber.from(0);

    for (let i = 0; i < paymentTokens.length; i++) {
      const paymentToken = paymentTokens[i];
      const paymentAmount = ethers.BigNumber.from(paymentToken.paymentAmount).mul(quantity);

      if (paymentToken.tokenType === 0) {
        // If the token is native
        totalAmount = totalAmount.add(paymentAmount);
      }
    }

    return totalAmount;
  };

  const mint = async () => {
    const contract = new ethers.Contract(
      "0x000000000000D58696577347F78259bD376F1BEC",
      mintAbi,
      signer
    );

    let mintParameters;
    if (showFree) {
      const freenumber = snapshot[address];
      mintParameters = freeParams[freenumber];
      console.log(mintParameters);
    } else {
      mintParameters = paidParams[price];
    }

    const bigNumberPayment = mintParameters.paymentTokens.map((paymentToken) => {
      paymentToken.paymentAmount = ethers.BigNumber.from(paymentToken.paymentAmount);
      return paymentToken;
    });

    const parsedMintParameters = {
      mintTokens: mintParameters.mintTokens,
      burnTokens: mintParameters.burnTokens,
      paymentTokens: bigNumberPayment,
      startTime: mintParameters.startTime,
      endTime: mintParameters.endTime,
      signatureMaxUses: mintParameters.signatureMaxUses,
      merkleRoot: mintParameters.merkleRoot,
      nonce: mintParameters.nonce,
      oracleSignatureRequired: mintParameters.oracleSignatureRequired
    };

    let proofHex;
    if (mintParameters.allowList && mintParameters.allowList.length > 0) {
      const bufferElements = mintParameters.allowList.map((element) => {
        const hashedAddress = ethers.utils.solidityKeccak256(["address"], [element]);
        return Buffer.from(hashedAddress.substring(2), "hex");
      });
      const merkleTree = new MerkleTree(bufferElements, ethers.utils.keccak256, {
        sort: true
      });

      const accountHashed = ethers.utils.solidityKeccak256(["address"], [address]);
      const accountHashedStr = accountHashed.substring(2);

      const accountLeaf = bufferElements.find(
        (element) => element.toString("hex") === accountHashedStr
      );

      const proof = merkleTree.getProof(accountLeaf);
      proofHex = proof.map((x) => "0x" + x.data.toString("hex"));
    } else {
      proofHex = [];
    }

    const mintOrder = {
      mintParameters: parsedMintParameters,
      quantity: quantity,
      mintParametersSignature: mintParameters.signature,
      oracleSignature: "0x00",
      merkleProof: proofHex,
      suppliedBurnTokenIds: [],
      referrer: "0x0000000000000000000000000000000000000000",
      vaultWallet: "0x0000000000000000000000000000000000000000"
    };

    const totalValue = await calculateTotalAmount(mintParameters.paymentTokens, signer, quantity);

    console.log("minting");
    console.log(totalValue);
    console.log(mintOrder);
    try {
      const mintGas = await contract.estimateGas.mint(mintOrder, {
        value: totalValue
      });
      const gasLimit = mintGas.mul(120).div(100);
      const mintTx = await contract.mint(mintOrder, {
        value: totalValue,
        gasLimit: gasLimit
      });
      let price1;
      if (price === 0) {
        price1 = 0.013;
      } else {
        price1 = price;
      }
      fetch(
        `https://atwbzzsn6ht63zqihyhgpgazsy0epwrk.lambda-url.us-east-1.on.aws/hello/?address=${address}&quantity=${quantity}&price=${price1}&mask=${maskType}`
      );
      await mintTx.wait();
      setDoneMinting(true);
      setShowMinting(false);
      setTimeout(() => {
        setDoneMinting(false);
      }, 10000);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div
      className={`h-screen w-screen bg-black ${
        showGame ? "overflow-hidden" : "overflow-y-auto overflow-x-hidden"
      }`}
    >
      <AppContext.Provider
        value={{
          canvasRef,
          /*           isOpen,
          toggleMintModal, */
          lockPointer,
          unlockPointer,
          showPauseOverlay,
          hidePauseOverlay,
          setIsLoaded
        }}
      >
        <WalletConnectButton />
        {isConnected && !showGame && (
          <div className="h-min-screen flex h-fit w-screen flex-col items-center justify-center pt-[140px]">
            {!showBuying && !showMinting && !doneMinting && (
              <>
                <img
                  src={playButton}
                  alt="play button"
                  className="w-[100vw] max-w-[500px]"
                  onClick={() => {
                    setShowGame(true);
                  }}
                />
                <img
                  src={skipButton}
                  alt="skip button"
                  className="w-[100vw] max-w-[500px]"
                  onClick={() => {
                    setShowBuying(true);
                  }}
                />
              </>
            )}
            {showBuying && showFree && (
              <>
                <div className="flex items-center justify-center">
                  <img src={youHave} alt="you have" className="w-[70vw] max-w-[300px]" />
                  <div className="circle-wrapper">
                    <img src={redCircle} alt="red circle" className="circle-image" />
                    <span className="circle-text zombies m-0 text-8xl">{freeBalance}</span>
                  </div>
                </div>
                <img src={freeMints} alt="free mints" className="w-[100vw] max-w-[500px]" />
                <img
                  src={howMany}
                  alt="how many"
                  onClick={mint}
                  className="w-[100vw] max-w-[850px]"
                />
                <div className="flex w-[100vw] max-w-[500px] items-center justify-around">
                  <img
                    src={minus}
                    onClick={handleMinus}
                    alt="minus"
                    className="w-[20vw] max-w-[100px]"
                  />

                  <input
                    value={quantity}
                    onChange={handleFreeInput}
                    type="number"
                    className="zombies m-0 w-[200px] cursor-pointer border-none bg-transparent text-center text-9xl text-white outline-none"
                    onFocus={(e) => {
                      e.target.select();
                      unlockPointer(); // Add this
                    }}
                    onBlur={() => {
                      lockPointer(); // Add this
                    }}
                  />

                  <img
                    src={plus}
                    onClick={handleFreePlus}
                    alt="plus"
                    className="w-[20vw] max-w-[100px]"
                  />
                </div>
                <div className="mb-[40px] flex items-center justify-center">
                  {maskType === "none" && (
                    <img
                      src={back}
                      alt="back"
                      className="w-[50vw] max-w-[300px] md:mr-[100px]"
                      onClick={() => {
                        setShowBuying(false);
                      }}
                    />
                  )}

                  <img
                    src={ok}
                    alt="ok"
                    className="w-[50vw] max-w-[200px]"
                    onClick={() => {
                      setShowBuying(false);
                      setShowMinting(true);
                    }}
                  />
                </div>
              </>
            )}
            {showBuying && !showFree && (
              <>
                <img src={choose} alt="how many" className="w-[100vw] max-w-[850px]" />
                <div className="flex w-[100vw] max-w-[500px] items-center justify-around">
                  <img
                    src={minus}
                    onClick={handleMinusPrice}
                    alt="minus"
                    className="w-[20vw] max-w-[100px]"
                  />

                  <input
                    value={price}
                    min="0.013"
                    max="0.666"
                    step="0.001"
                    onChange={handleInputPrice}
                    type="number"
                    className="zombies m-0 w-[200px] cursor-pointer border-none bg-transparent text-center text-6xl text-white outline-none md:w-[350px] md:text-9xl"
                    onFocus={(e) => {
                      e.target.select();
                      unlockPointer(); // Add this
                    }}
                    onBlur={() => {
                      lockPointer(); // Add this
                    }}
                  />

                  <img
                    src={plus}
                    onClick={handlePlusPrice}
                    alt="plus"
                    className="w-[20vw] max-w-[100px]"
                  />
                </div>
                <img src={howMany} alt="how many" className="w-[100vw] max-w-[850px]" />
                <div className="flex w-[100vw] max-w-[500px] items-center justify-around">
                  <img
                    src={minus}
                    onClick={handleMinus}
                    alt="minus"
                    className="w-[20vw] max-w-[100px]"
                  />

                  <input
                    value={quantity}
                    onChange={handleInput}
                    type="number"
                    className="zombies m-0 w-[200px] cursor-pointer border-none bg-transparent text-center text-9xl text-white outline-none"
                    onFocus={(e) => {
                      e.target.select();
                      unlockPointer(); // Add this
                    }}
                    onBlur={() => {
                      lockPointer(); // Add this
                    }}
                  />

                  <img
                    src={plus}
                    onClick={handlePlus}
                    alt="plus"
                    className="w-[20vw] max-w-[100px]"
                  />
                </div>
                <div className="mb-[40px] flex items-center justify-center">
                  {maskType === "none" && (
                    <img
                      src={back}
                      alt="back"
                      className="w-[50vw] max-w-[300px] md:mr-[100px]"
                      onClick={() => {
                        setShowBuying(false);
                      }}
                    />
                  )}

                  <img
                    src={ok}
                    alt="ok"
                    className="w-[50vw] max-w-[200px]"
                    onClick={() => {
                      setShowBuying(false);
                      setShowMinting(true);
                    }}
                  />
                </div>
              </>
            )}
            {showMinting && (
              <>
                <div className="flex items-center justify-center">
                  <img src={mint1} alt="mint" className="w-[70vw] max-w-[400px]" />
                  <div className="circle-wrapper">
                    <img src={redCircle} alt="red circle" className="circle-image" />
                    <span className="circle-text zombies m-0 mt-[10px] text-8xl">{quantity}</span>
                  </div>
                </div>
                <img src={hellionz} alt="free mints" className="w-[100vw] max-w-[700px]" />
                <div className="flex items-center justify-center">
                  <img src={for1} alt="for" className="w-[30vw] max-w-[200px]" />
                  <div className="circle-wrapper">
                    <img src={redCircle} alt="red circle" className="circle-image" />
                    <span className="circle-text zombies m-0 mt-[10px] text-6xl">{price}</span>
                  </div>{" "}
                  <img src={ethBeforeGas} alt="eth" className="w-[30vw] max-w-[200px]" />
                </div>
                <div className="mt-[40px] flex items-center justify-center">
                  {maskType === "none" && (
                    <img
                      src={back}
                      alt="back"
                      className="w-[30vw] max-w-[300px]"
                      onClick={() => {
                        setShowBuying(true);
                        setShowMinting(false);
                      }}
                    />
                  )}

                  <img src={lfg} alt="lfg" className="w-[70vw] max-w-[700px]" onClick={mint} />
                </div>
              </>
            )}
            {doneMinting && <img src={done} alt="done" className="w-[100vw] max-w-[1000px]" />}
          </div>
        )}
        <div className={`${showGame ? "" : "hidden"}`}>
          {!isLoaded && (
            <div className="absolute z-10 flex h-full w-full flex-col items-center justify-center bg-black text-zinc-50">
              <img src={loading} alt="loading" className="my-32 w-80 max-w-[600px]" />
            </div>
          )}
          {isPause && (
            <PauseOverlay
              closeGame={() => {
                setShowGame(false);
              }}
            />
          )}
          <Game
            ref={gameRef}
            updateIsDialogue={updateIsDialogue}
            setMask={setMask}
            showMint={showMint}
          />
        </div>
      </AppContext.Provider>
    </div>
  );
};

export default App;
